import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {connectAppEnv} from '../../../../app/app-env';
import {frefFromRef, frefToRef} from '../../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OELicensingAccessProvider from '../../../../react-oe/oe-licensing-access-provider';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {OEViewType} from '../../../../lib/oe-types';
import OEFNElement from '../../../elements/oe-flow-nav-elements';
import {OEThemeWaitingControllerWindow} from '../../oe-theme-waiting-controller';
import {OEFNStartSelectionModel, OEFNStartSelectionPropTypes} from './oe-fn-start-selection-model';
import {OEFNStartSelectiontCurrentItemTitleLabel, OEFNStartSelectionModuleBar, OEFNStartSelectionCategoryBar, OEFNStartSelectionCategory} from './oe-fn-start-selection-elements';

export class OEFlowNavStartSelectionView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.model = new OEFNStartSelectionModel(this.props.content);

        this.moduleLicensingAccess = this.moduleLicensingAccess.bind(this);
        this.itemLicensingAccess = this.itemLicensingAccess.bind(this);

        this.modules = this.model.createModulesState(this.props.target, this.moduleLicensingAccess, this.itemLicensingAccess);

        this.state = {
            modules:            this.modules,
            selectedModule:     this.model.getSelectedModuleIndex(this.props.target),
            currentModule:      this.model.getCurrentModuleIndex(this.props.target),
            areModulesHidden:   this.model.areModulesHidden(),
            strings: {
                model:          this.model.localizedStrings()
            },
            disabled:           this.determineDisabled()
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.onWaitingControllerRef = this.onWaitingControllerRef.bind(this);

        this.onModuleBarItemClick = this.onModuleBarItemClick.bind(this);
        this.onCategoryBarItemClick = this.onCategoryBarItemClick.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onDisabledItemClick = this.onDisabledItemClick.bind(this);
    }

    moduleLicensingAccess(module) {
        if(!this.props.moduleLicensingAccess)   return true;
        let access = this.props.moduleLicensingAccess(this, module, this.licensingAccess, this.oe);
        return access !== undefined ? !!access : true;
    }

    itemLicensingAccess(item, path) {
        if(!this.props.itemLicensingAccess)   return true;
        let access = this.props.itemLicensingAccess(this, item, path, this.licensingAccess, this.oe);
        return access !== undefined ? !!access : true;
    }

    componentWillReceiveProps(nextProps)   {
        let contentChanged = !OEToolbox.shallowEqual(nextProps.content, this.props.content, true);
        let targetChanged = nextProps.target !== this.props.target;

        if(contentChanged)   {
            this.model = new OEFNStartSelectionModel(nextProps.content);
            this.modules = this.model.createModulesState(nextProps.target, this.moduleLicensingAccess, this.itemLicensingAccess);

            this.setState({
                modules:            this.modules,
                selectedModule:     this.model.getSelectedModuleIndex(nextProps.target),
                currentModule:      this.model.getCurrentModuleIndex(this.props.target),
                areModulesHidden:   this.model.areModulesHidden()
            });
        }

        if(targetChanged && !contentChanged)   {
            this.setState({
                selectedModule:     this.model.getSelectedModuleIndex(nextProps.target),
                currentModule:      this.model.getCurrentModuleIndex(this.props.target)
            });
            this.setState({modules: this.model.updateSelectedCategoryState(this.modules, nextProps.target)});
        }

        if(nextProps.locStringPrefix !== this.props.locStringPrefix || contentChanged)  {
            this.updateLanguage(nextProps);
        }

        if(nextProps.licensingAccess !== this.props.licensingAccess)    {
            this.updateLicenseValidity(nextProps, !contentChanged);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    selectModule(index) {
        if(typeof(index) !== 'number')  return;
        this.setState({selectedModule: index});
    }

    selectCategory(index) {
        if(typeof(index) !== 'number')  return;

        this.setState(state => {
            if(state.selectedModule < 0)    return state;
            let newState = clone(state);
            let module = newState.modules[state.selectedModule];
            if(!module) return state;
            module.selectedCategory = index;
            return newState;
        });
    }
    
    determineDisabled(props)   {
        props = props || this.props;
        if(!this.licensingAccess.isLicensing || !props.licensingAccess)   return false;

        let access = props.licensingAccess(this, this.licensingAccess, this.oe);
        access = access !== undefined ? !!access : true;

        return !access;
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                model: this.model.localizedStrings(si)
            }
        });
    }

    updateLicenseValidity(props, updateModules = true)    {
        this.setState({disabled: this.determineDisabled(props)});
        if(updateModules)   this.setState({modules: this.model.updateDisabledState(this.modules, this.moduleLicensingAccess, this.itemLicensingAccess)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    onLicensingAccess(licensingAccess)  {
        this.licensingAccess = licensingAccess;
        this.updateLicenseValidity();
    }

    onWaitingControllerRef(ref) {
        this.waitingController = ref;
    }

    selectedModuleIndex()   {
        return this.state.selectedModule;
    }

    selectedModuleState()    {
        return this.state.selectedModule >= 0 ? this.state.modules[this.state.selectedModule] : undefined;
    }

    selectedCategoryIndex() {
        let module = this.selectedModuleState();
        return module && module.selectedCategory >= 0 ? module.selectedCategory : -1;
    }

    selectedCategoryState()    {
        let module = this.selectedModuleState();
        return module && module.selectedCategory >= 0 && Array.isArray(module.categories) ? module.categories[module.selectedCategory] : undefined;
    }

    renderModuleBar()    {
        if(!Array.isArray(this.state.modules) || this.state.areModulesHidden)    return null;

        return <OEFNStartSelectionModuleBar
            disabled={this.props.disabled || this.props.moduleBarDisabled}
            strings={this.state.strings.model}
            modules={this.state.modules}
            selected={this.state.selectedModule}
            current={this.state.currentModule}
            onItemClick={this.onModuleBarItemClick}
        />
    }

    renderCategoryBar(module)    {
        if(!module || !Array.isArray(module.categories) || module.categories.length == 0 || (module.categories.length == 1 && !module.categories[0].label))    return null;

        return <OEFNStartSelectionCategoryBar
            disabled={this.props.disabled || this.props.categoryBarDisabled}
            strings={this.state.strings.model}
            categories={module.categories}
            selected={module.selectedCategory}
            onItemClick={this.onCategoryBarItemClick}
        />
    }

    renderCategory(category, module)    {
        if(!category || !module) return null;

        return (
            <OEFNStartSelectionCategory
                target={this.props.target}
                disabled={this.props.disabled || this.state.disabled}
                itemsDisabled={this.props.itemsDisabled || module.disabled}
                currentItemInactive={this.props.currentItemInactive}
                categoryLabel={this.props.categoryLabel}
                category={category}
                strings={this.state.strings.model}
                onItemClick={this.onItemClick}
                onDisabledItemClick={this.onDisabledItemClick}
            />
        );
    }

    renderCategories(module)  {
        if(!module || !Array.isArray(module.categories))    return null;
        let selectedCategoryIndex = this.selectedCategoryIndex();

        return (
            <div className="layout-size-container">
                {module.categories.map((category, index) =>
                    <div key={index} className={'layout-size-container-item' + (selectedCategoryIndex != index ? ' invisible' : '') + (this.props.showFreePremiumView ? ' disable-active' : '')}>
                        {this.renderCategory(category, module)}
                    </div>
                )}
            </div>
        );
    }

    renderModule(module, hasModuleBar)    {
        if(!module) return null;
        let categoryBar = this.renderCategoryBar(module);

        return (
            <React.Fragment>
                {!categoryBar ? null :
                    <React.Fragment>
                        <OEFNElement.Spacer height={hasModuleBar ? '0.5em' : '0.375em'} /*hasModuleBar ? 8 : 6*//>
                        {categoryBar}
                        <OEFNElement.Spacer height="1.375em" /*22px*//>
                    </React.Fragment>
                }

                {hasModuleBar || categoryBar ? null : <OEFNElement.Spacer height="0.375em"/>}

                {this.renderCategories(module)}
                {/*this.renderCategory(this.selectedCategoryState(), module)*/}
            </React.Fragment>
        );
    }

    renderModules(hasModuleBar) {
        if(!Array.isArray(this.state.modules))    return null;
        let selectedModuleIndex = this.selectedModuleIndex();

        return (
            <div className="layout-size-container">
                {this.state.modules.map((module, index) =>
                    <div key={index} className={'layout-size-container-item' + (selectedModuleIndex != index ? ' invisible' : '')}>
                        {this.renderModule(module, hasModuleBar)}
                    </div>
                )}
            </div>
        );
    }

    render() {
        let moduleBar = this.renderModuleBar();

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={false} onLicensingAccess={this.onLicensingAccess}/>

                <OEFNElement.View className="start-selection">

                    <OEFNElement.Spacer height="1.125em" /*18px*//>

                    {!this.props.currentItemLabel ? null :
                        <OEFNStartSelectiontCurrentItemTitleLabel 
                            moduleId={this.props.moduleId}
                            target={this.props.target}
                            locStringPrefix={this.props.locStringPrefix}
                            content={this.props.content}
                        />
                    }

                    {!moduleBar ? null :
                        <React.Fragment>
                            {moduleBar}
                            <OEFNElement.Separator className="module-bar-separator"/>
                            <OEFNElement.Spacer height="1.5em" /*24px*//>
                        </React.Fragment>
                    }

                    {this.renderModules(!!moduleBar)}
                    {/*this.renderModule(this.selectedModuleState(), !!moduleBar)*/}

                    <OEFNElement.Spacer height="1.5em" /*24px*//>

                </OEFNElement.View>
                
                <OEThemeWaitingControllerWindow className="start-selection" ref={this.onWaitingControllerRef} options={{animated: false}}/>
            </React.Fragment>
        );
    }

    onModuleBarItemClick(sender, index)    {
        this.selectModule(index);
    }

    onCategoryBarItemClick(sender, index)    {
        this.selectCategory(index);
    }

    onItemClick(sender, item, id) {
        if(!this.props.appComponent)    return;

        this.waitingController.show(null, () => {
            window.requestAnimationFrame(() => {
                if(this.props.onItemClick && this.props.onItemClick(this, item, id !== this.props.target))  {
                    if(this.waitingController)  this.waitingController.hide();
                    return;
                }
                this.props.appComponent.app.changeTarget(id);
                if(this.waitingController)  this.waitingController.hide();
            });
        });
    }

    onDisabledItemClick(sender, item, id)   {
        if(!this.props.showFreePremiumView) return;
        let view = OEViewType.getRef(OEViewType.freePremium, this.props.appComponent);
        
        if(view && view.setOpen) {
            view.setOpen(true, {
                blurBackdrop: {
                    ruleName:   'start-selection-free-premium-blur-modal-backdrop',
                    selector:   'body .start-selection-view, body .start-view'
                }
            });
        }
    }
}

OEFlowNavStartSelectionView.defaultProps = {
    moduleId:               '',
    target:                 '',
    locStringPrefix:        '',
    disabled:               false,
    moduleBarDisabled:      false,
    categoryBarDisabled:    false,
    itemsDisabled:          false,
    currentItemInactive:    true,
    currentItemLabel:       false,
    categoryLabel:          false,
    showFreePremiumView:    false
};

OEFlowNavStartSelectionView.propTypes = OEFNStartSelectionPropTypes.decl;

//
export default frefFromRef(connectAppEnv((env) => {
    const {showLogo, ...rest} = env.config.module.uiLayerConfig.startSelection;
    return {
        target:         env.config.target,
        appComponent:   env.component,
        ...rest
    };
})(frefToRef(OEFlowNavStartSelectionView)));